import request from '@/utils/request'

export interface CardPricing {
  issuancePrice: number
  loadingRate: number
}

interface CardPricingResponse {
  data: {
    type: string
    attributes: {
      issuance_price: number
      loading_rate: number
    }
  }
}

export const getCardPricing = async (): Promise<CardPricing> => {
  const response = await request({
    url: '/market/v1/card_pricing',
    method: 'get'
  }) as CardPricingResponse

  return {
    issuancePrice: response.data.attributes.issuance_price,
    loadingRate: response.data.attributes.loading_rate
  }
}
